"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolStatusResponseToJSON = exports.CommunityPoolStatusResponseFromJSONTyped = exports.CommunityPoolStatusResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CommunityPoolStatusResponseFromJSON(json) {
    return CommunityPoolStatusResponseFromJSONTyped(json, false);
}
exports.CommunityPoolStatusResponseFromJSON = CommunityPoolStatusResponseFromJSON;
function CommunityPoolStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isEligible': !(0, runtime_1.exists)(json, 'isEligible') ? undefined : json['isEligible'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, _1.CommunityPoolStatusFromJSON)(json['status']),
        'invitationStatus': !(0, runtime_1.exists)(json, 'invitationStatus') ? undefined : (0, _1.CommunityPoolInvitationStatusFromJSON)(json['invitationStatus']),
        'totalCreditsUsd': !(0, runtime_1.exists)(json, 'totalCreditsUsd') ? undefined : json['totalCreditsUsd'],
        'creditsBySource': !(0, runtime_1.exists)(json, 'creditsBySource') ? undefined : (0, _1.CommunityPoolCreditsBySourceFromJSON)(json['creditsBySource']),
        'invitedAt': !(0, runtime_1.exists)(json, 'invitedAt') ? undefined : (new Date(json['invitedAt'])),
        'termsAcceptedAt': !(0, runtime_1.exists)(json, 'termsAcceptedAt') ? undefined : (new Date(json['termsAcceptedAt'])),
    };
}
exports.CommunityPoolStatusResponseFromJSONTyped = CommunityPoolStatusResponseFromJSONTyped;
function CommunityPoolStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isEligible': value.isEligible,
        'status': (0, _1.CommunityPoolStatusToJSON)(value.status),
        'invitationStatus': (0, _1.CommunityPoolInvitationStatusToJSON)(value.invitationStatus),
        'totalCreditsUsd': value.totalCreditsUsd,
        'creditsBySource': (0, _1.CommunityPoolCreditsBySourceToJSON)(value.creditsBySource),
        'invitedAt': value.invitedAt === undefined ? undefined : (value.invitedAt.toISOString()),
        'termsAcceptedAt': value.termsAcceptedAt === undefined ? undefined : (value.termsAcceptedAt.toISOString()),
    };
}
exports.CommunityPoolStatusResponseToJSON = CommunityPoolStatusResponseToJSON;
